import React from 'react';
import { SelectItem } from '../../widgets/SelectItem';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

const DGApplicationEditForm = React.forwardRef((props, ref) => {
    const [FinancialYear, setFinancialYear] = React.useState(null);
    const [DGType, setDGType] = React.useState(null);



    const showDGIntervention = (FinancialYearID, DGTypeID) => {
        if (FinancialYearID != undefined) { setFinancialYear(FinancialYearID.Id) }
        if (DGTypeID != undefined) { setDGType(DGTypeID.Id) }
    }

    return (
        <EntityForm ref={ref} viewId="organisation" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            dataURL='api/sims/dgapplication/getfind'
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="organisationWSPandATRForms">


                            <table cellPadding="2" width="80%">
                            <tbody>
                             <tr>
                                        <td>
                                            <SelectItem
                                                dataUrl="api/sims/dgapplication/getlookuplist?listid=FinancialYear"
                                                id="FinancialYearID"
                                                label="Financial Year"
                                                className="w-100"
                                                required={true}
                                                disabled
                                                form={form} />
                                        </td>

                                    <td>
                                    <SelectItem
                                            dataUrl="api/sims/dgapplication/getlookuplist?listid=DiscGrantType"
                                            id="DGTypeID"
                                            label="Grant Type"
                                            required={true}
                                            className="w-100"
                                            disabled
                                            form={form} />
                                            
                                    </td>
                                </tr>
                             <tr>

                                 <td>
                                    <SelectItem
                                        dataUrl="api/sims/dgapplication/getlookuplist?listid=DGIntervention"
                                         id="DGInterventionID"
                                         required={true}
                                         hidden={showDGIntervention(form.values["FinancialYearID"], form.values["DGTypeID"])}
                                         label="Intervention Type"
                                         disabled={FinancialYear!=null && DGType!=null?false:true}
                                         className="w-100"
                                         disabled
                                         form={form} />
                                </td>
                                <td>
                                    <SelectItem
                                        dataUrl={'api/sims/DGApplication/GetDGStatusByRole?parameter=[{"Name":"DGApplicationID","Value":' + props.id + '}]'}
                                        id="DGStatusID"
                                        label="DG Status"
                                        className="w-100"
                                        form={form}
                                    />
                                </td>
                             </tr>
                                </tbody>
                            </table>
                    
                </form >
            }
        </EntityForm >
    );
})

export default DGApplicationEditForm;
